import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages(
    'pages.RequestFormPage.NetSuiteVendorCreationPopupContent.NetSuiteVendorCreationPopupForm',
    {
        createButton: 'Create',
    }
);
